import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FilterMenu } from '../../shared/models/filter-menu';
import { SortMenu } from '../../shared/models/sort-menu';
import { PanelList } from '../../shared/models/panel-list';
import { DocumentAuditTrialDetails } from '../models/document-audit-trial-details';
import { CommonService } from '../../shared/services/common.service';


@Component({
  selector: 'app-document-audit-summary',
  templateUrl: './document-audit-summary.component.html',
  styleUrls: ['./document-audit-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentAuditSummaryComponent implements OnInit {
  @Input() auditSummaryDetails!: DocumentAuditTrialDetails[];
  @Output() attributeDetailsOfTransaction = new EventEmitter();
  isDocumentAuditSummaryLoaded: boolean = false;
  documentAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight:true
  };
  noData: boolean = false;

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.bindDocumentAuditSummary();
    this.noData = this.commonService.IsListEmpty(this.documentAuditSummaryInput.lists);    
  }

  bindDocumentAuditSummary = () => {
    this.documentAuditSummaryInput.lists = this.auditSummaryDetails;
    this.documentAuditSummaryInput.filters = this.getFiltersForDocumentAuditList();
    this.documentAuditSummaryInput.sort = this.getSortFieldsForDocumentAuditList();
    this.documentAuditSummaryInput.clearSelection = true;
    this.isDocumentAuditSummaryLoaded = true;
    this.documentAuditSummaryInput = { ...this.documentAuditSummaryInput };
  }
  private getFiltersForDocumentAuditList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'User',
        filterFieldName: 'user',
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action',
      }
    );
    return filters;
  };
  private getSortFieldsForDocumentAuditList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user',
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action',
      }
    );
    return sortMenu;
  };
  showAuditAttributeDetails = (data: any) => {
    this.attributeDetailsOfTransaction.emit(data);;
  }
}
